// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-inputs .form-control {
  height: 40px;
}

.form-inputs .form-control:focus {
  box-shadow: none;
  border: 1px solid #000;
}

.form-control {
  min-width: 250px;
}

.search-icon {
  margin-right: 40px;
  background-color: #333742;
  padding-left: 13px;
  padding-right: 13px;
  padding-top: 10px;
  padding-bottom: 10px;
  color: rgb(210, 207, 207);
  border-radius: 16%;
  cursor: pointer;
}
.search-icon:hover {
  color: white;
  background-color: #3b71ca;
  transition: all 0.4s ease-in-out;
}`, "",{"version":3,"sources":["webpack://./src/app/features/user-management/roles/role-search/role-search.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;;AAEA;EACE,gBAAA;EACA,sBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AACF;AACE;EACE,YAAA;EACA,yBAAA;EACA,gCAAA;AACJ","sourcesContent":[".form-inputs .form-control {\n  height: 40px;\n}\n\n.form-inputs .form-control:focus {\n  box-shadow: none;\n  border: 1px solid #000;\n}\n\n.form-control {\n  min-width: 250px;\n}\n\n.search-icon {\n  margin-right: 40px;\n  background-color: #333742;\n  padding-left: 13px;\n  padding-right: 13px;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  color: rgb(210, 207, 207);\n  border-radius: 16%;\n  cursor: pointer;\n\n  &:hover {\n    color: white;\n    background-color: #3b71ca;\n    transition: all 0.4s ease-in-out;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
